import { notify } from '@/Ship/Helpers/notify'

/** Додаткові параметри повідомлення: дія по кліку (перетворює його на посилання) */
export interface NotificationOptions {
    /** Викликається по кліку на повідомлення або на кнопку дії */
    onClick?: () => void
    /** Підпис кнопки дії, коли задано onClick */
    actionLabel?: string
}

type Show = (title?: string, description?: string, options?: NotificationOptions) => void

const withDescription =
    (fn: typeof notify.success): Show =>
    (title, description, options) => {
        fn(title, { ...options, ...(description ? { description } : {}) })
    }

const api = {
    showSuccess: withDescription(notify.success),
    showError: withDescription(notify.error),
    showInfo: withDescription(notify.info),
    showWarning: withDescription(notify.warning),
}

/**
 * Замість Core useNotification (той показує справа зверху): той самий API
 * showSuccess/showError(title, description, options) + showInfo/showWarning,
 * але через єдиний Ship notify — справа знизу, один формат для всієї системи.
 */
export const useNotification = () => api
